import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    'Atenção: As variáveis de ambiente REACT_APP_SUPABASE_URL ou REACT_APP_SUPABASE_ANON_KEY não foram encontradas. Garanta que o arquivo .env esteja configurado.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
